const headerWrap = "nitro-ui__Header-module__header-wrap";
const pageMainHeader = "nitro-ui__Header-module__page-main-header";
const scrolled = "nitro-ui__Header-module__scrolled";
const subRoundHeader = "nitro-ui__Header-module__sub-round-header";
const title = "nitro-ui__Header-module__title";
const mainHeaderWrap = "nitro-ui__Header-module__main-header-wrap";
const header = "nitro-ui__Header-module__header";
const headerInnerBg = "nitro-ui__Header-module__header-inner-bg";
const shadowNone = "nitro-ui__Header-module__shadow-none";
const headerTitle = "nitro-ui__Header-module__header-title";
const iconNew = "nitro-ui__Header-module__icon-new";
const pageMainHeaderWrap = "nitro-ui__Header-module__page-main-header-wrap";
const pageMainInner = "nitro-ui__Header-module__page-main-inner";
const pageMainSwitch = "nitro-ui__Header-module__page-main-switch";
const subHeaderFixed = "nitro-ui__Header-module__sub-header-fixed";
const subBgHeader = "nitro-ui__Header-module__sub-bg-header";
const ico = "nitro-ui__Header-module__ico";
const subMainHeader = "nitro-ui__Header-module__sub-main-header";
const arrowIcon = "nitro-ui__Header-module__arrow-icon";
const subHeaderWrap = "nitro-ui__Header-module__sub-header-wrap";
const subHeaderFlex = "nitro-ui__Header-module__sub-header-flex";
const subHeaderInfo = "nitro-ui__Header-module__sub-header-info";
const comfyHeaderWrap = "nitro-ui__Header-module__comfy-header-wrap";
const comfyHeaderToggle = "nitro-ui__Header-module__comfy-header-toggle";
const comfyHeaderMenu = "nitro-ui__Header-module__comfy-header-menu";
const desktopNavWrap = "nitro-ui__Header-module__desktop-nav-wrap";
const focus = "nitro-ui__Header-module__focus";
const menuDepthWrap = "nitro-ui__Header-module__menu-depth-wrap";
const desktopNavClose = "nitro-ui__Header-module__desktop-nav-close";
const hover = "nitro-ui__Header-module__hover";
const desktopNavInner = "nitro-ui__Header-module__desktop-nav-inner";
const logo = "nitro-ui__Header-module__logo";
const desktopNavContainerType = "nitro-ui__Header-module__desktop-nav-container-type";
const desktopNavTit = "nitro-ui__Header-module__desktop-nav-tit";
const active = "nitro-ui__Header-module__active";
const desktopNavItems = "nitro-ui__Header-module__desktop-nav-items";
const desktopNavItemsInner = "nitro-ui__Header-module__desktop-nav-items-inner";
const desktopNavContainer = "nitro-ui__Header-module__desktop-nav-container";
const desktopNavItem = "nitro-ui__Header-module__desktop-nav-item";
const menuDepth = "nitro-ui__Header-module__menu-depth";
const desktopHeaderInfo = "nitro-ui__Header-module__desktop-header-info";
const desktopHeaderInfoInner = "nitro-ui__Header-module__desktop-header-info-inner";
const innerBg = "nitro-ui__Header-module__inner-bg";
const desktopPreloginInfo = "nitro-ui__Header-module__desktop-prelogin-info";
const linkTxt = "nitro-ui__Header-module__link-txt";
const block = "nitro-ui__Header-module__block";
const hidden = "nitro-ui__Header-module__hidden";
const styles = {
	"header-wrap": "nitro-ui__Header-module__header-wrap",
	headerWrap: headerWrap,
	"page-main-header": "nitro-ui__Header-module__page-main-header",
	pageMainHeader: pageMainHeader,
	scrolled: scrolled,
	"sub-round-header": "nitro-ui__Header-module__sub-round-header",
	subRoundHeader: subRoundHeader,
	title: title,
	"main-header-wrap": "nitro-ui__Header-module__main-header-wrap",
	mainHeaderWrap: mainHeaderWrap,
	header: header,
	"header-inner-bg": "nitro-ui__Header-module__header-inner-bg",
	headerInnerBg: headerInnerBg,
	"shadow-none": "nitro-ui__Header-module__shadow-none",
	shadowNone: shadowNone,
	"header-title": "nitro-ui__Header-module__header-title",
	headerTitle: headerTitle,
	"icon-new": "nitro-ui__Header-module__icon-new",
	iconNew: iconNew,
	"page-main-header-wrap": "nitro-ui__Header-module__page-main-header-wrap",
	pageMainHeaderWrap: pageMainHeaderWrap,
	"page-main-inner": "nitro-ui__Header-module__page-main-inner",
	pageMainInner: pageMainInner,
	"page-main-switch": "nitro-ui__Header-module__page-main-switch",
	pageMainSwitch: pageMainSwitch,
	"sub-header-fixed": "nitro-ui__Header-module__sub-header-fixed",
	subHeaderFixed: subHeaderFixed,
	"sub-bg-header": "nitro-ui__Header-module__sub-bg-header",
	subBgHeader: subBgHeader,
	ico: ico,
	"sub-main-header": "nitro-ui__Header-module__sub-main-header",
	subMainHeader: subMainHeader,
	"arrow-icon": "nitro-ui__Header-module__arrow-icon",
	arrowIcon: arrowIcon,
	"sub-header-wrap": "nitro-ui__Header-module__sub-header-wrap",
	subHeaderWrap: subHeaderWrap,
	"sub-header-flex": "nitro-ui__Header-module__sub-header-flex",
	subHeaderFlex: subHeaderFlex,
	"sub-header-info": "nitro-ui__Header-module__sub-header-info",
	subHeaderInfo: subHeaderInfo,
	"comfy-header-wrap": "nitro-ui__Header-module__comfy-header-wrap",
	comfyHeaderWrap: comfyHeaderWrap,
	"comfy-header-toggle": "nitro-ui__Header-module__comfy-header-toggle",
	comfyHeaderToggle: comfyHeaderToggle,
	"comfy-header-menu": "nitro-ui__Header-module__comfy-header-menu",
	comfyHeaderMenu: comfyHeaderMenu,
	"desktop-nav-wrap": "nitro-ui__Header-module__desktop-nav-wrap",
	desktopNavWrap: desktopNavWrap,
	focus: focus,
	"menu-depth-wrap": "nitro-ui__Header-module__menu-depth-wrap",
	menuDepthWrap: menuDepthWrap,
	"desktop-nav-close": "nitro-ui__Header-module__desktop-nav-close",
	desktopNavClose: desktopNavClose,
	hover: hover,
	"desktop-nav-inner": "nitro-ui__Header-module__desktop-nav-inner",
	desktopNavInner: desktopNavInner,
	logo: logo,
	"desktop-nav-container-type": "nitro-ui__Header-module__desktop-nav-container-type",
	desktopNavContainerType: desktopNavContainerType,
	"desktop-nav-tit": "nitro-ui__Header-module__desktop-nav-tit",
	desktopNavTit: desktopNavTit,
	active: active,
	"desktop-nav-items": "nitro-ui__Header-module__desktop-nav-items",
	desktopNavItems: desktopNavItems,
	"desktop-nav-items-inner": "nitro-ui__Header-module__desktop-nav-items-inner",
	desktopNavItemsInner: desktopNavItemsInner,
	"desktop-nav-container": "nitro-ui__Header-module__desktop-nav-container",
	desktopNavContainer: desktopNavContainer,
	"desktop-nav-item": "nitro-ui__Header-module__desktop-nav-item",
	desktopNavItem: desktopNavItem,
	"menu-depth": "nitro-ui__Header-module__menu-depth",
	menuDepth: menuDepth,
	"desktop-header-info": "nitro-ui__Header-module__desktop-header-info",
	desktopHeaderInfo: desktopHeaderInfo,
	"desktop-header-info-inner": "nitro-ui__Header-module__desktop-header-info-inner",
	desktopHeaderInfoInner: desktopHeaderInfoInner,
	"inner-bg": "nitro-ui__Header-module__inner-bg",
	innerBg: innerBg,
	"desktop-prelogin-info": "nitro-ui__Header-module__desktop-prelogin-info",
	desktopPreloginInfo: desktopPreloginInfo,
	"link-txt": "nitro-ui__Header-module__link-txt",
	linkTxt: linkTxt,
	block: block,
	hidden: hidden
};

export { active, arrowIcon, block, comfyHeaderMenu, comfyHeaderToggle, comfyHeaderWrap, styles as default, desktopHeaderInfo, desktopHeaderInfoInner, desktopNavClose, desktopNavContainer, desktopNavContainerType, desktopNavInner, desktopNavItem, desktopNavItems, desktopNavItemsInner, desktopNavTit, desktopNavWrap, desktopPreloginInfo, focus, header, headerInnerBg, headerTitle, headerWrap, hidden, hover, ico, iconNew, innerBg, linkTxt, logo, mainHeaderWrap, menuDepth, menuDepthWrap, pageMainHeader, pageMainHeaderWrap, pageMainInner, pageMainSwitch, scrolled, shadowNone, subBgHeader, subHeaderFixed, subHeaderFlex, subHeaderInfo, subHeaderWrap, subMainHeader, subRoundHeader, title };
